import React, { useState, useEffect } from 'react';

import { Equifaxv2Error } from "./data";

const TransUnionReportModal2 = ({
  isOpen,
  onClose,
  TransUnionReport,
  Equifaxv2Error,
  displayMessageBlock = true,
  reportMessage = "",
  reportCode = "",
}) => {
  const [isPrinting, setIsPrinting] = useState(false);


  useEffect(() => {
   // console.log("data",TransUnionReport);
  }, [TransUnionReport], [Equifaxv2Error]);

  if (!isOpen) return null; // Do not render anything if not open




  const printDiv = () => {
  setIsPrinting(true);

  const printWindow = window.open('', '', 'height=700,width=1000');

  const printContents = document.getElementById("invoicedata").innerHTML;

  printWindow.document.write(`
    <html>
      <head>
        <title>TransUnion Report</title>
        <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
        <style>
          @media print {
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
              color-adjust: exact !important;
            }
            .cibil-cyan {
              color: #00acd7 !important;
            }
            .cibil-yellow-bg {
              background-color: #f8d406 !important;
            }
              .textpx{
              font-size:11px !important;
              }
          }
        </style>
      </head>
      <body>${printContents}</body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
    setIsPrinting(false);
  }, 200);
};




  const idTypeMapPersonal = {
  SocialId: "Social Id",
  TaxId: "PAN",
  RationCardId: "Ration Card No",
  CkycId: "CKYC Id",
};

  const responses = TransUnionReport?.credit_report[0]?.accounts || "";
  const modalDataError = Equifaxv2Error && Equifaxv2Error;

const buildYearlyHistory = (payStatusArray = []) => {
  const months = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
  const history = {};

  payStatusArray.forEach(item => {
    const date = new Date(item.date);
    const year = date.getFullYear();
    const monthIndex = date.getMonth();

    if (!history[year]) {
      history[year] = Array(12).fill("-");
    }

    history[year][monthIndex] = item.status || "000";
  });

  return { months, history };
};



  return (
    <div className="fixed inset-0 flex  flex-col items-center justify-center z-50 backdrop-blur-sm bg-white bg-opacity-50 md:p-0 p-2">
      <div className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]" id="invoicedata">
        <div className="a4-page">



          {displayMessageBlock && (() => {
            const message =
              Equifaxv2Error?.error?.credit_report_message?.message ||
              Equifaxv2Error?.message ||
              TransUnionReport?.message ||
              reportMessage ||
              "";

            const code =
              Equifaxv2Error?.error?.credit_report_message?.message_code ||
              Equifaxv2Error?.message_code ||
              TransUnionReport?.message_code ||
              reportCode ||
              "";

            const isSuccess = /sucess|success/i.test(message);

            //  Don't show anything if it's success
            if (isSuccess) return null;

            const formatText = (text) =>
              text?.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

            return (
              <>{(message?.length > 0 || code?.length > 0) && (
                <div className="flex flex-col items-center justify-center my-2">
                  <div className="bg-red-50 border border-red-400 rounded-md p-1 w-full md:w-3/4">
                    <p className="text-center text-black font-bold">
                      Error: <span className="font-normal">{formatText(message)}</span>
                    </p>
                    <p className="text-center text-black font-bold mt-1">
                      Code: <span className="font-normal">{formatText(code)}</span>
                    </p>
                  </div>
                </div>
              )}
              </>
            );
          })()}

  <div className="w-full">
  {/* Top Row - 100% Dynamic */}
  <div className="grid grid-cols-12 items-center">
    {/* Left Side: Report details - Dynamic */}
    <div className="col-span-9 flex items-center text-[10px] mt-2">
      {(() => {
        const formatKey = (key) => {
          return key
            .replace(/([A-Z])/g, ' $1')
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' ')
            .trim();
        };

        const headerData = TransUnionReport?.InquiryResponseHeader || {};
        const scoreData = TransUnionReport?.credit_report?.[0]?.scores?.[0] || {};

        const items = [];

        // Add score date and time
        if (scoreData.scoreDate || headerData.Time) {
          items.push(
            <span key="datetime">
              <span className="font-semibold cibil-cyan text-cyan-500">
                {formatKey('report_date_time')}:
              </span>
              <span className="ml-1">
                {scoreData.scoreDate || "N/A"} ({headerData.Time || "N/A"})
              </span>
            </span>
          );
        }

        // Add all other header fields dynamically
        Object.entries(headerData).forEach(([key, value]) => {
          if (value && key !== 'Time') {
            items.push(
              <span key={key} className="flex items-center">
                <span className="mx-3 text-gray-500">|</span>
                <span className="font-semibold text-cyan-500 cibil-cyan">
                  {formatKey(key)}:
                </span>
                <span className="ml-1">{value}</span>
              </span>
            );
          }
        });

        return items;
      })()}
    </div>

    {/* Right Side: Logo */}
    <div className="col-span-3 flex justify-end p-0">
      <img
        src="https://imgs.search.brave.com/PS09ni7k-MWeOfPvQ0sD4xlRP7Myn_oTAu2Kf3jFHqs/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pLnRy/YWN4bi5jb20vbG9n/by9jb21wYW55L1Nj/cmVlbnNob3RfM185/Zjc4YzYwZS1mNjg1/LTQ4ZjItYTNhOC02/OTIyOTU4YjZiYTYu/cG5nP2Zvcm1hdD13/ZWJwJmhlaWdodD0x/MjAmd2lkdGg9MTIw"
        className="w-40"
        alt="Logo"
      />
    </div>
  </div>

  {/* Yellow Line */}
  <div className="bg-yellow-400 h-1 w-[80%] md:w-[80%] mt-[-8px]"></div>
</div>

{/* Consumer Information - 100% Dynamic */}
<div className='flex justify-start mb-3'>
  <p className='font-semibold text-black text-sm ml-3'>Consumer Information</p>
</div>

<div className="border border-gray-300 rounded-md overflow-hidden">
  {(() => {
    const formatKey = (key) => {
      return key
        .replace(/([A-Z])/g, ' $1')
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .trim();
    };

    const creditReport = TransUnionReport?.credit_report?.[0] || {};
    const consumerData = {};

    // Add name from root or names array
    if (TransUnionReport?.name) {
      consumerData['name'] = TransUnionReport.name;
    } else if (creditReport.names?.[0]?.name) {
      consumerData['name'] = creditReport.names[0].name;
    }

    // Add all fields from names array
    if (creditReport.names?.[0]) {
      Object.entries(creditReport.names[0]).forEach(([key, value]) => {
        if (value && key !== 'index') {
          consumerData[key] = value;
        }
      });
    }

    // Add all IDs dynamically
    if (Array.isArray(creditReport.ids)) {
      creditReport.ids.forEach(id => {
        if (id.idNumber && id.idType) {
          consumerData[id.idType] = id.idNumber;
        }
      });
    }

    // Add telephone
    if (creditReport.telephones?.[0]?.telephoneNumber) {
      consumerData['telephone'] = creditReport.telephones[0].telephoneNumber;
    }

    // Add email
    if (creditReport.emails?.[0]?.emailAddress) {
      consumerData['email'] = creditReport.emails[0].emailAddress;
    }

    // Add employment info
    if (creditReport.employment?.[0]) {
      Object.entries(creditReport.employment[0]).forEach(([key, value]) => {
        if (value && key !== 'index') {
          consumerData[key] = value;
        }
      });
    }

    // Add fallback data
    if (modalDataError?.name) consumerData['name'] = consumerData['name'] || modalDataError.name;
    if (modalDataError?.data?.name) consumerData['name'] = consumerData['name'] || modalDataError.data.name;

    if (Object.keys(consumerData).length === 0) {
      return <p className="text-center text-gray-500 py-4">No consumer information available</p>;
    }

    return (
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-2 gap-0">
        {Object.entries(consumerData).map(([key, value]) => (
          <div key={key} className="border-b lg:border-b-0 lg:border-r border-gray-300 p-2">
            <p className="text-[8px] textpx uppercase font-semibold text-cyan-500 cibil-cyan">
              {formatKey(key)}: 
              <span className="ml-2 text-[9px] text-black font-medium normal-case">
                {value || "-"}
              </span>
            </p>
          </div>
        ))}
      </div>
    );
  })()}
</div>

<hr className="my-1" />
{/* Credit Score Section - 100% Dynamic */}
<div className="md:text-black p-1 text-black mt-2 rounded-tr-md rounded-tl-md text-xs border">
  CIBIL TRANSUNION SCORE(S)
</div>

<table className="min-w-full table-auto border text-left">
  {(() => {
    const formatKey = (key) => {
      return key
        .replace(/([A-Z])/g, ' $1')
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .trim();
    };

    const scores = TransUnionReport?.credit_report?.[0]?.scores;
    const normalizedScores = Array.isArray(scores) ? scores : scores ? [scores] : [];

    if (normalizedScores.length === 0) {
      return (
        <tbody>
          <tr>
            <td className="border px-2 py-4 text-center text-gray-500">
              No scores available
            </td>
          </tr>
        </tbody>
      );
    }

    // Get all unique keys from all score objects (excluding nested arrays/objects)
    const allKeys = new Set();
    normalizedScores.forEach(score => {
      if (score && typeof score === 'object') {
        Object.keys(score).forEach(key => {
          // Skip nested arrays like reasonCodes
          if (!Array.isArray(score[key]) && typeof score[key] !== 'object') {
            allKeys.add(key);
          }
        });
      }
    });

    const displayKeys = Array.from(allKeys);

    // Identify the main score field (contains "score" in key name)
    const scoreField = displayKeys.find(key => 
      key.toLowerCase() === 'score' || key.toLowerCase().includes('score')
    );

    // Other fields (non-score fields)
    const otherFields = displayKeys.filter(key => key !== scoreField);

    return (
      <>
        <thead className="text-[11px] font-semibold text-cyan-500 cibil-cyan">
          <tr className='text-left text-sm'>
            {otherFields.map((key) => (
              <th key={key} className="border px-1 py-0">
                {formatKey(key)}
              </th>
            ))}
            {scoreField && (
              <th className="border px-1 py-0">
                {formatKey(scoreField)}
              </th>
            )}
          </tr>
        </thead>
        <tbody className="scoreDetailsInfo text-[11px]">
          {normalizedScores.map((scoreDetail, index) => (
            <tr key={index}>
              {otherFields.map((key) => (
                <td key={key} className="border px-1 py-0">
                  {scoreDetail?.[key] || "N/A"}
                </td>
              ))}
              {scoreField && (
                <td className="border px-1">
                  <div className="flex flex-col items-center justify-center bg-green-300 rounded-lg border-green-700 border p-1 w-16 h-12">
                    <span className="text-2xl font-bold text-blue-900">
                      {scoreDetail?.[scoreField] || "N/A"}
                    </span>
                    <span className="text-xs font-semibold text-cyan-600">
                      {formatKey(scoreField)}
                    </span>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </>
    );
  })()}
</table>

{/* Reason Codes Section - 100% Dynamic (if needed) */}
{(() => {
  const scores = TransUnionReport?.credit_report?.[0]?.scores;
  const normalizedScores = Array.isArray(scores) ? scores : scores ? [scores] : [];
  
  // Check if any score has reason codes
  const hasReasonCodes = normalizedScores.some(score => 
    Array.isArray(score?.reasonCodes) && score.reasonCodes.length > 0
  );

  if (!hasReasonCodes) return null;

  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
      .trim();
  };

  return (
    <>
      <div className="md:text-black p-1 text-black mt-2 rounded-tr-md rounded-tl-md text-xs border">
        Score Factors
      </div>
      <table className="min-w-full table-auto border text-left">
        {normalizedScores.map((scoreDetail, scoreIdx) => {
          const reasonCodes = scoreDetail?.reasonCodes || [];
          
          if (reasonCodes.length === 0) return null;

          // Get all unique keys from reason codes
          const allKeys = new Set();
          reasonCodes.forEach(reason => {
            if (reason && typeof reason === 'object') {
              Object.keys(reason).forEach(key => allKeys.add(key));
            }
          });

          const displayKeys = Array.from(allKeys);

          return (
            <React.Fragment key={scoreIdx}>
              {scoreIdx > 0 && <div className="h-2"></div>}
              
              <thead className="text-[11px] font-semibold text-cyan-500 cibil-cyan bg-gray-100">
                <tr>
                  <th className="border px-1 py-0">#</th>
                  {displayKeys.map((key) => (
                    <th key={key} className="border px-1 py-0">
                      {formatKey(key)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="text-[11px]">
                {reasonCodes.map((reason, reasonIdx) => (
                  <tr key={reasonIdx}>
                    <td className="border px-1 py-0 text-center font-semibold">
                      {reasonIdx + 1}
                    </td>
                    {displayKeys.map((key) => (
                      <td key={key} className="border px-1 py-0">
                        {reason?.[key] || "N/A"}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>  
            </React.Fragment>
          );
        })}
      </table>
    </>
  );
})()}


{/* Reported Address - 100% Dynamic */}
<div className="md:text-black text-black p-1 mt-1 rounded-tr-xl rounded-tl-xl text-xs font-semibold border">
  Reported Address
</div>

<table className="min-w-full table-auto border text-left">
  {(() => {
    const formatKey = (key) => {
      return key
        .replace(/([A-Z])/g, ' $1')
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
        .trim();
    };

    const formatValue = (key, value) => {
      if (!value || value === '') return 'N/A';
      
      // Handle address category mapping
      if (key === 'addressCategory') {
        const categoryMap = {
          '01': 'Residential',
          '02': 'Office',
          '03': 'Permanent',
          '04': 'Temporary',
          '05': 'Business',
          '06': 'Not Categorized'
        };
        return categoryMap[value] || value;
      }

      // Handle state code mapping (if needed)
      if (key === 'stateCode') {
        const stateMap = {
          '01': 'Jammu & Kashmir',
          '02': 'Himachal Pradesh',
          '03': 'Punjab',
          '04': 'Chandigarh',
          '05': 'Uttarakhand',
          '06': 'Haryana',
          '07': 'Delhi',
          '08': 'Rajasthan',
          '09': 'Uttar Pradesh',
          '10': 'Bihar',
          '11': 'Sikkim',
          '12': 'Arunachal Pradesh',
          '13': 'Nagaland',
          '14': 'Manipur',
          '15': 'Mizoram',
          '16': 'Tripura',
          '17': 'Meghalaya',
          '18': 'Assam',
          '19': 'West Bengal',
          '20': 'Jharkhand',
          '21': 'Odisha',
          '22': 'Chhattisgarh',
          '23': 'Madhya Pradesh',
          '24': 'Gujarat',
          '25': 'Daman & Diu',
          '26': 'Dadra & Nagar Haveli',
          '27': 'Maharashtra',
          '28': 'Andhra Pradesh',
          '29': 'Karnataka',
          '30': 'Goa',
          '31': 'Lakshadweep',
          '32': 'Kerala',
          '33': 'Tamil Nadu',
          '34': 'Puducherry',
          '35': 'Andaman & Nicobar',
          '36': 'Telangana'
        };
        return stateMap[value] || value;
      }

      return value;
    };

    // Get addresses from correct path
    const addresses = TransUnionReport?.credit_report?.[0]?.addresses || [];

    if (!Array.isArray(addresses) || addresses.length === 0) {
      return (
        <tbody>
          <tr>
            <td className="border px-2 py-4 text-center text-gray-500">
              No address information available
            </td>
          </tr>
        </tbody>
      );
    }

    // Get all unique keys from all addresses (excluding 'index')
    const allKeys = new Set();
    addresses.forEach(addr => {
      if (addr && typeof addr === 'object') {
        Object.keys(addr).forEach(key => {
          if (key !== 'index') {
            allKeys.add(key);
          }
        });
      }
    });

    // Filter to show only fields with data in at least one address
    const displayKeys = Array.from(allKeys).filter(key => {
      return addresses.some(addr => addr[key] && addr[key] !== '');
    });

    if (displayKeys.length === 0) {
      return (
        <tbody>
          <tr>
            <td className="border px-2 py-4 text-center text-gray-500">
              No address data available
            </td>
          </tr>
        </tbody>
      );
    }

    return (
      <>
        <thead>
          <tr className='text-[10px] md:text-cyan-500 text-cyan-500 cibil-cyan font-semibold'>
            <th className="border md:text-cyan-500 text-cyan-500 cibil-cyan px-1 py-0">
              S.No.
            </th>
            {displayKeys.map((key) => (
              <th key={key} className="border md:text-cyan-500 text-cyan-500 cibil-cyan px-1 py-0">
                {formatKey(key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="address-info text-[10px]">
          {addresses.map((address, index) => (
            <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
              <td className="border px-1 py-0 text-center font-semibold">
                {index + 1}
              </td>
              {displayKeys.map((key) => (
                <td key={key} className="border px-1">
                  {formatValue(key, address[key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </>
    );
  })()}
</table>







     

{/* Consumer Account Details */}
<div className="text-black p-1 mt-2 rounded-tr-md rounded-tl-md">
  <h3 className="font-bold text-lg mb-2">Consumer Account Details</h3>
</div>

<table className="min-w-full table-auto text-left border-collapse">
  <tbody>
    {(() => {
      const accounts = TransUnionReport?.credit_report?.accounts || responses;
      
      if (!accounts || !Array.isArray(accounts) || accounts.length === 0) {
        return (
          <tr>
            <td className="text-center py-8 text-gray-500">
              No account data available
            </td>
          </tr>
        );
      }

      // Helper to format keys - removes camelCase and adds spaces
      const formatKey = (key) => {
        if (!key) return '';
        return key
          .replace(/([A-Z])/g, ' $1') // Add space before capital letters
          .replace(/^./, (str) => str.toUpperCase()) // Capitalize first letter
          .trim();
      };

      // Helper to format values
      const formatValue = (key, value) => {
        if (value === null || value === undefined || value === '' || value === '-1' || value === 'NA') {
          return 'N/A';
        }

        const keyLower = key.toLowerCase();
        
        // Add ₹ for amount/balance fields
        if (keyLower.includes('amount') || keyLower.includes('balance') || keyLower.includes('credit')) {
          if (!isNaN(value)) {
            return `₹${parseFloat(value).toLocaleString('en-IN')}`;
          }
        }
        
        // Add % for rate/percentage fields
        if (keyLower.includes('rate') && !isNaN(value)) {
          return `${value}%`;
        }
        
        // Add months for tenure/term fields
        if ((keyLower.includes('tenure') || keyLower.includes('term')) && !isNaN(value)) {
          return `${value} months`;
        }
        
        return value;
      };

      // Helper to get color for values
      const getValueColor = (key, value) => {
        const keyLower = key.toLowerCase();
        
        if (keyLower.includes('overdue') && parseFloat(value) > 0) {
          return 'text-red-600 font-bold';
        }
        
        if (keyLower.includes('status') && (value === 'ACTIVE' || value === 'Active')) {
          return 'text-green-600 font-bold';
        }
        
        return '';
      };

      // Group fields by section
      const categorizeFields = (account) => {
        const accountInfo = [];
        const amounts = [];
        const status = [];
        const excludeKeys = ['monthlyPayStatus', 'index', 'paymentHistory'];

        Object.entries(account).forEach(([key, value]) => {
          if (excludeKeys.includes(key)) return;

          const keyLower = key.toLowerCase();
          
          // Categorize by keywords
          if (keyLower.includes('amount') || keyLower.includes('balance') || 
              keyLower.includes('credit') || keyLower.includes('emi') || 
              keyLower.includes('rate') || keyLower.includes('tenure') || 
              keyLower.includes('term')) {
            amounts.push([key, value]);
          } else if (keyLower.includes('status') || keyLower.includes('date') || 
                     keyLower.includes('frequency') || keyLower.includes('payment')) {
            status.push([key, value]);
          } else {
            accountInfo.push([key, value]);
          }
        });

        return { accountInfo, amounts, status };
      };

      return (
        <tr>
          <td colSpan={6} className="px-1 py-0">
            {accounts.map((account, idx) => {
              // Build payment history
              const { months, history } = buildYearlyHistory(
                account?.monthlyPayStatus || []
              );

              // Categorize fields dynamically
              const { accountInfo, amounts, status } = categorizeFields(account);

              return (
                <div key={idx} className="mb-4">
                  <span className='text-black text-sm font-semibold mb-1 block'>
                    {idx + 1}. Account
                  </span>
                  
                  <div className="border rounded p-2 bg-white text-black shadow-sm">
                    {/* Header with key dates */}
                    <h5 className="font-semibold bg-gray-100 p-2 text-xs rounded-tl-xl rounded-tr-xl flex flex-wrap gap-x-5 gap-y-1">
                      <span className="text-cyan-500 cibil-cyan text-sm">
                        Loan Type: <span className="text-black">{account?.accountType || 'N/A'}</span>
                      </span>
                      <span className="text-gray-300">|</span>
                      <span className="text-cyan-500 cibil-cyan">
                        Open Date: <span className="text-black">{account?.dateOpened || 'N/A'}</span>
                      </span>
                      <span className="text-gray-300">|</span>
                      <span className="text-cyan-500 cibil-cyan">
                        Date Closed: <span className="text-black">{account?.dateClosed || 'N/A'}</span>
                      </span>
                      <span className="text-gray-300">|</span>
                      <span className="text-cyan-500 cibil-cyan">
                        Reported On: <span className="text-black">{account?.dateReported || 'N/A'}</span>
                      </span>
                    </h5>

                    {/* 3 MAIN COLUMNS - Fully Dynamic */}
                    <div className="grid grid-cols-3 md:grid-cols-3 gap-2 text-xs mt-2 p-2">
                      {/* ACCOUNT SECTION */}
                      <div className="border-r pr-3">
                        <h3 className="font-bold text-black mb-2 tracking-wide">ACCOUNT</h3>
                        <div className="space-y-1.5">
                          {accountInfo.map(([key, value], fIdx) => {
                            const formattedValue = formatValue(key, value);
                            if (formattedValue === 'N/A') return null;

                            return (
                              <p key={fIdx} className="text-black">
                                <span className="inline-block w-40 font-semibold text-cyan-500 cibil-cyan">
                                  {formatKey(key)}:
                                </span>
                                <span className={getValueColor(key, value)}>
                                  {formattedValue}
                                </span>
                              </p>
                            );
                          })}
                        </div>
                      </div>

                      {/* AMOUNTS SECTION */}
                      <div className="border-r pr-3">
                        <h3 className="font-bold text-black mb-2 tracking-wide">AMOUNTS</h3>
                        <div className="space-y-1.5">
                          {amounts.map(([key, value], fIdx) => {
                            const formattedValue = formatValue(key, value);
                            if (formattedValue === 'N/A') return null;

                            return (
                              <p key={fIdx} className="text-black">
                                <span className="inline-block w-40 font-semibold text-cyan-500 cibil-cyan">
                                  {formatKey(key)}:
                                </span>
                                <span className={getValueColor(key, value)}>
                                  {formattedValue}
                                </span>
                              </p>
                            );
                          })}
                        </div>
                      </div>

                      {/* STATUS SECTION */}
                      <div className="pl-3">
                        <h3 className="font-bold text-black mb-2 tracking-wide">STATUS</h3>
                        <div className="space-y-1.5">
                          {status.map(([key, value], fIdx) => {
                            const formattedValue = formatValue(key, value);
                            if (formattedValue === 'N/A') return null;

                            return (
                              <p key={fIdx} className="text-black">
                                <span className="inline-block w-40 font-semibold text-cyan-500 cibil-cyan">
                                  {formatKey(key)}:
                                </span>
                                <span className={getValueColor(key, value)}>
                                  {formattedValue}
                                </span>
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    </div>

                    {/* PAYMENT HISTORY */}
                    {account?.monthlyPayStatus && account.monthlyPayStatus.length > 0 && (
                      <div className="border mt-3 rounded-md overflow-hidden text-xs">
                        <div className="flex flex-wrap justify-between px-3 py-2 text-[10px] border-b bg-gray-100">
                          <span className='text-sm text-black font-semibold'>DAYS PAST DUE / ASSET CLASSIFICATION</span>
                          <p className='text-cyan-500 cibil-cyan'>
                            START DATE: <span className='text-black'>{account?.dateOpened || "-"}</span>
                          </p>
                          <p className='text-cyan-500 cibil-cyan'>
                            | END DATE: <span className='text-black'>{account?.dateClosed || "Active"}</span>
                          </p>
                          <p className='text-cyan-500 cibil-cyan'>
                            | LAST PAYMENT: <span className='text-black'>{account?.lastPaymentDate || "-"}</span>
                          </p>
                        </div>

                        <div className="overflow-x-auto">
                          <table className="w-full text-center border-collapse">
                            <thead>
                              <tr className="bg-slate-50 border-b">
                                <th className="p-1 text-cyan-500 cibil-cyan font-bold">YEAR</th>
                                {months.map((m, idx) => (
                                  <th key={idx} className="p-1 text-cyan-500 cibil-cyan font-semibold tracking-wide">
                                    {m}
                                  </th>
                                ))}
                              </tr>
                            </thead>

                            <tbody>
                              {Object.keys(history)
                                .sort((a, b) => b - a)
                                .map((year, yIdx) => (
                                  <tr key={yIdx} className="border-b hover:bg-gray-50">
                                    <td className="p-1 font-bold text-cyan-500 cibil-cyan">{year}</td>
                                    {history[year].map((value, mIdx) => {
                                      const statusNum = parseInt(value);
                                      let colorClass = 'text-gray-400';
                                      
                                      if (value !== '-') {
                                        if (statusNum === 0) colorClass = 'text-gray-500';
                                        else if ([22, 24, 25].includes(statusNum)) colorClass = 'text-green-700 font-semibold';
                                        else if (statusNum === 32) colorClass = 'text-yellow-600 font-bold';
                                        else if ([47, 55].includes(statusNum)) colorClass = 'text-red-600 font-bold';
                                        else colorClass = 'text-blue-600 font-semibold';
                                      }

                                      return (
                                        <td key={mIdx} className="p-1">
                                          <span className={colorClass}>
                                            {value === '-' ? '-' : value.padStart(3, '0')}
                                          </span>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* LEGEND */}
                    <div className="mt-3 flex flex-wrap gap-3 text-xs bg-gray-50 p-2 rounded">
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-green-600 inline-block"></span>
                        Standard (STD / 22 / 24 / 25)
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-yellow-400 inline-block"></span>
                        Past Due (32)
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-red-600 inline-block"></span>
                        Default (47 / 55)
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-gray-500 inline-block"></span>
                        Not Reported (0)
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-blue-600 inline-block"></span>
                        Special (XXX)
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </td>
        </tr>
      );
    })()}
  </tbody>
</table>




{/* Inquiry History Section */}
<div className="text-black p-1 mt-1 rounded-tr-md rounded-tl-md text-sm font-semibold">
  Inquiry History
</div>

<table className="min-w-full table-auto text-left border-collapse text-[10px]">
  {(() => {
    const enquiries = TransUnionReport?.credit_report?.enquiries || 
                      TransUnionReport?.credit_report?.[0]?.enquiries || 
                      [];
    
    if (!Array.isArray(enquiries) || enquiries.length === 0) {
      return (
        <tbody>
          <tr>
            <td className="text-center py-8 text-gray-500" colSpan="100%">
              No inquiry data available
            </td>
          </tr>
        </tbody>
      );
    }

    // Helper to format keys - converts camelCase to readable text
    const formatKey = (key) => {
      if (!key) return '';
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
    };

    // Helper to format values
    const formatValue = (key, value) => {
      if (value === null || value === undefined || value === '') {
        return 'N/A';
      }

      const keyLower = key.toLowerCase();

      // Handle amount fields
      if (keyLower.includes('amount')) {
        if (!isNaN(value)) {
          return `₹${parseFloat(value).toLocaleString('en-IN')}`;
        }
      }

      // Handle purpose codes
      if (keyLower === 'enquirypurpose' || keyLower === 'purpose') {
        const purposeMap = {
          '00': 'Other',
          '01': 'Personal Loan',
          '02': 'Home Loan',
          '03': 'Auto Loan',
          '04': 'Credit Card',
          '05': 'Loan / Credit',
          '06': 'Business Loan',
          '07': 'Educational Loan',
          '08': 'Agriculture Loan',
          '09': 'Property Loan',
          '10': 'Micro Finance'
        };
        return purposeMap[value] || value;
      }

      // Handle arrays (like remarks)
      if (Array.isArray(value)) {
        return value.length > 0 ? value.join(', ') : 'N/A';
      }

      return value;
    };

    // Get color class for values
    const getColorClass = (key, value) => {
      const keyLower = key.toLowerCase();

      if (keyLower.includes('member') || keyLower.includes('name')) {
        return 'text-cyan-500 font-semibold';
      }

      if (keyLower.includes('amount')) {
        return 'text-green-600 font-semibold';
      }

      if (keyLower.includes('purpose')) {
        return 'text-yellow-600';
      }

      if (keyLower.includes('date')) {
        return 'text-blue-600';
      }

      return 'text-gray-700';
    };

    // Get all unique keys from all enquiries
    const allKeys = new Set();
    enquiries.forEach(enquiry => {
      Object.keys(enquiry).forEach(key => {
        if (key !== 'index') { // Skip index field
          allKeys.add(key);
        }
      });
    });

    const headers = Array.from(allKeys);

    return (
      <>
        <thead>
          <tr className="bg-gray-200">
            {headers.map((key, idx) => (
              <th key={idx} className="px-2 py-1 border font-semibold text-gray-700">
                {formatKey(key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {enquiries.map((enquiry, index) => (
            <tr key={index} className="border text-gray-700 hover:bg-gray-100">
              {headers.map((key, idx) => {
                const value = enquiry[key];
                const formattedValue = formatValue(key, value);
                const colorClass = getColorClass(key, value);

                return (
                  <td key={idx} className={`border px-2 py-1 ${colorClass}`}>
                    {formattedValue}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </>
    );
  })()}
</table>





{/* Account Summary Section - 100% Dynamic */}
{(() => {
  const accountSummary = TransUnionReport?.credit_report?.[0]?.response?.consumerSummaryresp?.accountSummary || 
                        TransUnionReport?.credit_report?.accountSummary || 
                        {};

  const formatKey = (key) => {
    if (!key) return '';
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/(\d+)/g, ' $1 ')
      .replace(/^./, (str) => str.toUpperCase())
      .trim()
      .replace(/\s+/g, ' ');
  };

  const formatValue = (key, value) => {
    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }

    // Format numbers
    if (typeof value === 'number') {
      return value.toLocaleString('en-IN');
    }

    // Format amounts
    const keyLower = key.toLowerCase();
    if ((keyLower.includes('amount') || keyLower.includes('balance')) && !isNaN(value)) {
      return `₹${parseFloat(value).toLocaleString('en-IN')}`;
    }

    return value;
  };

  const getColorClass = (key, value) => {
    const keyLower = key.toLowerCase();

    // Red for overdue
    if (keyLower.includes('overdue') && value && value !== 'N/A' && value !== 0) {
      return 'text-red-600 font-bold';
    }

    // Green for zero balance or no overdue
    if ((keyLower.includes('zero') || keyLower.includes('overdue')) && (value === 0 || value === '0')) {
      return 'text-green-600 font-semibold';
    }

    // Blue for totals
    if (keyLower.includes('total')) {
      return 'text-blue-700 font-bold';
    }

    // Purple for balances
    if (keyLower.includes('balance') || keyLower.includes('amount')) {
      return 'text-purple-600 font-semibold';
    }

    return 'text-gray-700';
  };

  const keys = Object.keys(accountSummary);

  if (keys.length === 0) return null;

  return (
    <>
      <div className="md:text-black text-black p-1 mt-2 rounded-tr-md rounded-tl-md text-xs border">
        Account Summary
      </div>

      <table className="min-w-full table-auto border text-left">
        <thead className="bg-gray-100">
          <tr className='text-xs text-cyan-500 cibil-cyan'>
            {keys.map((key) => (
              <th key={key} className="border px-2 py-1">
                {formatKey(key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr className="border text-center text-xs">
            {keys.map((key) => {
              const value = accountSummary[key];
              const formattedValue = formatValue(key, value);
              const colorClass = getColorClass(key, value);

              return (
                <td key={key} className={`border px-2 py-1 ${colorClass}`}>
                  {formattedValue}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </>
  );
})()}

{/* Inquiry Summary Section - 100% Dynamic */}
<div className="md:text-black text-black p-1 mt-2 rounded-tr-md rounded-tl-md text-xs border">
  Recent Activity (Last 90 Days)
</div>

<table className="min-w-full table-auto border text-left">
  {(() => {
    const inquirySummary = TransUnionReport?.credit_report?.[0]?.response?.consumerSummaryresp?.inquirySummary || 
                           TransUnionReport?.credit_report?.inquirySummary || 
                           {};

    const formatKey = (key) => {
      if (!key) return '';
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/(\d+)/g, ' $1 ')
        .replace(/^./, (str) => str.toUpperCase())
        .trim()
        .replace(/\s+/g, ' ');
    };

    const formatValue = (key, value) => {
      if (value === null || value === undefined || value === '') {
        return 'N/A';
      }

      const keyLower = key.toLowerCase();

      // Format date fields
      if (keyLower.includes('date')) {
        return value;
      }

      // Format numbers
      if (typeof value === 'number') {
        return value.toLocaleString('en-IN');
      }

      return value;
    };

    const getColorClass = (key, value) => {
      const keyLower = key.toLowerCase();

      // Red for high inquiry counts
      if (keyLower.includes('total') && typeof value === 'number' && value > 5) {
        return 'text-red-600 font-bold';
      }

      // Yellow for recent inquiries (30 days)
      if (keyLower.includes('30') || keyLower.includes('recent')) {
        if (value && value !== 'N/A' && value !== '' && value !== 0) {
          return 'text-yellow-600 font-semibold';
        }
      }

      // Orange for 12 months
      if (keyLower.includes('12')) {
        if (value && value !== 'N/A' && value !== '' && value !== 0) {
          return 'text-orange-600 font-semibold';
        }
      }

      // Green for low/no inquiries
      if (typeof value === 'number' && value === 0) {
        return 'text-green-600';
      }

      // Blue for dates
      if (keyLower.includes('date')) {
        return 'text-blue-600';
      }

      return 'text-gray-700';
    };

    const keys = Object.keys(inquirySummary);

    if (keys.length === 0) {
      return (
        <tbody>
          <tr>
            <td className="text-center py-8 text-gray-500" colSpan="100%">
              No inquiry summary data available
            </td>
          </tr>
        </tbody>
      );
    }

    return (
      <>
        <thead className="bg-gray-100">
          <tr className='text-xs text-cyan-500 cibil-cyan'>
            {keys.map((key) => (
              <th key={key} className="border px-2 py-1">
                {formatKey(key)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="recentActivity">
          <tr className="border border-black text-center text-xs">
            {keys.map((key) => {
              const value = inquirySummary[key];
              const formattedValue = formatValue(key, value);
              const colorClass = getColorClass(key, value);

              return (
                <td key={key} className={`border px-2 py-1 ${colorClass}`}>
                  {formattedValue}
                </td>
              );
            })}
          </tr>
        </tbody>
      </>
    );
  })()}
</table>

{/* Combined Summary Cards - 100% Dynamic (Optional Alternative View) */}
{(() => {
  const accountSummary = TransUnionReport?.credit_report?.[0]?.response?.consumerSummaryresp?.accountSummary || {};
  const inquirySummary = TransUnionReport?.credit_report?.[0]?.response?.consumerSummaryresp?.inquirySummary || {};

  const allSummaries = {
    ...accountSummary,
    ...inquirySummary
  };

  const formatKey = (key) => {
    return key
      .replace(/([A-Z])/g, ' $1')
      .replace(/(\d+)/g, ' $1 ')
      .replace(/^./, (str) => str.toUpperCase())
      .trim()
      .replace(/\s+/g, ' ');
  };

  const formatValue = (key, value) => {
    if (value === null || value === undefined || value === '') {
      return 'N/A';
    }

    const keyLower = key.toLowerCase();

    if ((keyLower.includes('amount') || keyLower.includes('balance')) && !isNaN(value)) {
      return `₹${parseFloat(value).toLocaleString('en-IN')}`;
    }

    if (typeof value === 'number') {
      return value.toLocaleString('en-IN');
    }

    return value;
  };

  const getCardColor = (key, value) => {
    const keyLower = key.toLowerCase();

    if (keyLower.includes('overdue') && value && value !== 'N/A' && value !== 0) {
      return 'border-red-500 bg-red-50';
    }

    if (keyLower.includes('total')) {
      return 'border-blue-500 bg-blue-50';
    }

    if (keyLower.includes('30')) {
      return 'border-yellow-500 bg-yellow-50';
    }

    return 'border-gray-300 bg-white';
  };

  if (Object.keys(allSummaries).length === 0) return null;

  return (
    <>
      <div className="md:text-black text-black p-1 mt-2 rounded-tr-md rounded-tl-md text-xs font-semibold">
        Summary Overview
      </div>

      <div className="grid grid-cols-4 md:grid-cols-4 gap-1 p-2">
        {Object.entries(allSummaries).map(([key, value]) => {
          const formattedValue = formatValue(key, value);
          if (formattedValue === 'N/A') return null;

          return (
            <div
              key={key}
              className={`border-2 rounded-lg p-2 text-center ${getCardColor(key, value)}`}
            >
              <p className="text-[10px] text-gray-600 font-semibold uppercase mb-1">
                {formatKey(key)}
              </p>
              <p className="text-lg font-bold text-gray-800">
                {formattedValue}
              </p>
            </div>
          );
        })}
      </div>
    </>
  );
})()}



        </div>

        


  <div className="mt-2 border">
  <h4 className="text-md font-semibold text-gray-700 mb-2 px-2">
    CIR DATA GLOSSARY
  </h4>

  <div className="grid grid-cols-3 sm:grid-cols-3 gap-1 text-[10px] bg-white p-2 rounded shadow">

    {/* Row - Report Name */}
    <div className="font-bold text-cyan-600 bg-gray-100 rounded-sm px-1 py-0">Report Section</div>
    <div className="font-bold text-cyan-600 bg-gray-100 rounded-sm px-1 py-0">Key Term / Code</div>
    <div className="font-bold text-cyan-600 bg-gray-100 rounded-sm px-1 py-0">Description</div>

    <div>Report name</div>
    <div>-</div>
    <div>Consumer CIR</div>

    {/* Row - Consumer Details */}
    <div>Consumer Details</div>
    <div>e</div>
    <div>Enriched through Enquiry</div>

    {/* Row - Identification */}
    <div>Identification(s)</div>
    <div>ID Types</div>
    <div>PAN, Passport, Voter ID, DL, Ration, UID</div>

    {/* Row - Telephone */}
    <div>Telephone(s)</div>
    <div>Telephone Types</div>
    <div>Latest 4 telephone details reported</div>

    {/* Row - Email */}
    <div>Email Contact(s)</div>
    <div>-</div>
    <div>Latest 4 emails reported</div>

    {/* Row - Employment */}
    <div>Employment Information(s)</div>
    <div>Occupation Codes</div>
    <div>Salaried, Self Employed, Others</div>

    {/* Row - Address */}
    <div>Address(es)</div>
    <div>Address Category</div>
    <div>Latest 4 addresses: Permanent, Residence, Office</div>

    {/* Row - Account Status */}
    <div>Consumer Account Details</div>
    <div>Account Information</div>
    <div>Active = Not closed, Inactive = Closed</div>

    {/* Row - DPD */}
    <div>Consumer Account Details</div>
    <div>DPD / Asset Classification</div>
    <div>STD, SMA, SUB, DBT, LSS, 000-900, XXX</div>

    {/* Row - Dispute */}
    <div>Consumer Account Details</div>
    <div>Information under dispute</div>
    <div>Grievance raised by consumer regarding correctness</div>

    {/* Row – Enquiry */}
    <div>Enquiry Details</div>
    <div>-</div>
    <div>Enquiries made with other members</div>

  </div>
</div>




        <div className='mt-2'>
  <h3 className="text-green-800 text-center font-bold">END of Report  {" "}
                  :{" "}
                  {TransUnionReport?.name ||
                    modalDataError?.data?.name ||
                    modalDataError?.name ||
                    modalDataError?.error?.name ||
                    "N/A"}</h3>
</div>
      </div>


      <div className="flex justify-center mt-2">
        <button
          className="bg-green-500 text-white p-2 rounded hover:bg-green-700"
          onClick={printDiv}
          disabled={isPrinting}
        >
          Print
        </button>
        <button
          className="bg-red-500 text-white p-2 rounded hover:bg-red-700"
          onClick={onClose} // This should close the modal
        >
          Close
        </button>
      </div>
    </div >
  );
};

export default TransUnionReportModal2;
